import { inject, type InjectionKey } from 'vue'
import type { OperacoesCatalogoGrupoDeLocaisDeTrabalho } from '../catalogo-grupo-de-locais-de-trabalho.tipos'

export const CHAVE_OPERACOES_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO:
InjectionKey<OperacoesCatalogoGrupoDeLocaisDeTrabalho> = Symbol(
  'operacoes-catalogo-grupo-de-locais-de-trabalho',
)

export const usarOperacoesCatalogoGrupoDeLocaisDeTrabalho = (
): OperacoesCatalogoGrupoDeLocaisDeTrabalho => {
  const operacoes = inject(
    CHAVE_OPERACOES_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO,
  )
  if (!operacoes) throw new Error('Catalogo de grupo de locais nao foi instalado')
  return operacoes
}
